export default __webpack_public_path__ + "static/media/Classwin logo_Classwin Horizontal - Blue 2.82befecd.png";